import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import CreateFormInput from '../CreateFormInput';
import { colors } from '../../Utils/Colors';
import { serverUrls } from '../../Utils/Urls';
import { getInvestigation, getInvestigationFailure, getInvestigationSuccess,resetInvestigationState } from '../../Actions/patientAction';
import { connect } from 'react-redux';
import axios from 'axios';

const formInputs = {
    hb: {
        type: 'text',
        label: "HB 12-18 (g/dl)"
    },
    na: {
        type: 'text',
        label: 'Na 135-145 (mmol/L)'
    },
    bloodUrea: {
        type: 'text',
        label: 'Blood Urea 10-50 (mg/dL)'
    },
    sCreatinine: {
        type: 'text',
        label: 'S. Creatinine 0.5-1.2 (mg/dL)'
    },
    sUricAcid: {
        type: 'text',
        label: 'S. Uric acid 3.4-7.0 (mg/dL)'
    },
    sPhosphorus: {
        type: 'text',
        label: 'S. Phosphorus 2.7-4.5 (mg/dL)'
    },
    sCalcium: {
        type: 'text',
        label: 'S. Calcium 8.6-10.2 (mg/dL)'
    },
    albumin: {
        type: 'text',
        label: 'Albumin 3.4-4.8 (g/dL)'
    },
    sAlkalinePhosphate: {
        type: 'text',
        label: 'S. Alkaline phosphate 42-128 (U/L)'
    },
    sIPTH: {
        type: 'text',
        label: 'S. iPTH 15-65 (pg/ml)'
    },
    ohVitD: {
        type: 'text',
        label: '25(OH) Vit D 11.1-42.9 (ng/ml)'
    },
    urineCa: {
        type: 'text',
        label: '24 hr urine Ca 50-300 (mg/TV)'
    },
    urineCr: {
        type: 'text',
        label: '24 hr urine Cr  (mg/TV)'
    },
    urineP: {
        type: 'text',
        label: '24 hr urine P 400-1300 (mg/TV)'
    },
    tmpGFR: {
        type: 'text',
        label: 'Tmp/GFR (mg/dl)'
    },
    TC: {
        type: 'text',
        label: 'TC 150-200 (mg/dL)'
    },
    TG: {
        type: 'text',
        label: 'TG 50-200 (mg/dL)'
    },
    LDL: {
        type: 'text',
        label: 'LDL <130 (mg/dL)'
    },
    HDL: {
        type: 'text',
        label: 'HDL 33-55 (mg/dL)'
    },
    sgot: {
        type: 'text',
        label: 'SGOT 2-40 (U/L)'
    },
    sgpt: {
        type: 'text',
        label: 'SGPT 2-40 (U/L)'
    },
    bilirubin: {
        type: 'text',
        label: 'Bilirubin 0.2-1.2 (mg/dL)'
    },
    fgf_23: {
        type: 'text',
        label: 'FGF-23 (RU/ml)'
    },
    igf1: {
        type: 'text',
        label: 'IGF1 (ng/ml)'
    },
    betaCrosslaps: {
        type: 'text',
        label: 'Beta Crosslaps 89-837 (ng/ml)'
    },
    p1np: {
        type: 'text',
        label: 'P1NP 14.28-76.31 (ng/ml)'
    },
    t3: {
        type: 'text',
        label: 'T3 0.8-2 (ng/ml)'
    },
    t4: {
        type: 'text',
        label: 'T4 4.8-12.7 (μg/dl)'
    },
    tsh: {
        type: 'text',
        label: 'TSH 0.27-4.2 (μlU/ml)'
    },
}

class Investigation extends React.Component {

    componentDidMount() {
        this.props.getInvestigationEdit(serverUrls.investigation + this.props.id + '/');
    }
    componentWillUnmount() {
        this.props.resetInvestigationState();
      }

    render() {
        var url = serverUrls.investigation + this.props.id + '/';
        return (
            <Container style={{maxWidth: 800, background: colors.lightGrey}}>
                <br/>
                <h4>Investigation</h4>
                <br/>
                <Row>
                    <Col sm={{size: 10, offset:2}}>
                        <Row>
                            <Col sm={{size: 10, offset:2}}>
                                <h6>Follow Ups</h6>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={2}>
                                <h6>At Presentation</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>3 Months</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>6 Months</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>1 year</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>2 year</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>5 year</h6>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <CreateFormInput size={2} label={false} count={6} isPost={false} buttonName="Save" url={url} formName="getInvestigation" inputs={formInputs} />
                <br/>
                <br/>
            </Container>
        )
    }
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        getInvestigationEdit: (url) => {
            dispatch(getInvestigation({loading: true}));
            axios.get(url).then((res)=>{
                dispatch(getInvestigationSuccess({loading: false, success: res.data.success, data: res.data}));
            }).catch((err)=>{
                dispatch(getInvestigationFailure({loading: false}));
            });
        },
        resetInvestigationState: () => {
            dispatch(resetInvestigationState());
          },

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Investigation);
